import { DialogBody, DialogContainer, DialogHeader } from '@wg/wows-react-uikit';
import { useTranslation } from 'react-i18next';
import HeaderSubtitle from '~/Components/HeaderSubtitle/HeaderSubtitle';
import { AvailableOnBegining } from '~/Components/Messages/Messages';
import StartBoosters from '~/Components/StartBoosters/StartBoosters';

const StartBuyDialog = () => {
    const { t } = useTranslation();

    return (
        <DialogContainer>
            <DialogHeader>{t('Завершение этапов')}</DialogHeader>
            <DialogBody>
                <HeaderSubtitle>
                    <AvailableOnBegining />
                </HeaderSubtitle>
                <StartBoosters />
            </DialogBody>
        </DialogContainer>
    );
};

export default StartBuyDialog;
